import { format, isValid, parse, startOfDay } from 'date-fns';
import { formatDateStringToObject } from 'syf-js-utilities';
import { getEndDateForPayment, getMaximumPaymentDays } from '../../../../helpers';
import { getDateError, isValidDateFormat } from '../../../../machines/oneTimePayment/paymentDateConfig';
import { t } from '../../../../strings/i18n';
export const DATE_FORMAT = 'MM/dd/yyyy';
export const getValidDate = (val) => {
    if (!val)
        return null;
    if (val instanceof Date && isValid(val)) {
        return val;
    }
    if (typeof val === 'string') {
        const parsedDate = parse(val, DATE_FORMAT, new Date());
        if (parsedDate instanceof Date && !Number.isNaN(parsedDate.getTime())) {
            return parsedDate;
        }
        const d = formatDateStringToObject(val);
        return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
    }
    return null;
};
// eslint-disable-next-line max-lines-per-function
function datePickerValidation(accountSummaryResponse, startDate, endDate) {
    return (value) => {
        if (value === null || value === undefined || value === '') {
            return t('errors.paymentDate');
        }
        let date;
        if (!isValid(value)) {
            date = parse(value, 'MM/dd/yyyy', new Date());
        }
        else {
            date = value;
        }
        if (Number.isNaN(date.getTime())) {
            return t('errors.invalidDateFormat');
        }
        const formattedDate = format(date, 'yyyy-MM-dd');
        const startOfDayValue = startOfDay(getValidDate(value));
        if (startOfDayValue < getValidDate(startDate) ||
            startOfDayValue > getValidDate(endDate)) {
            return t('multiPaymentFlow.selectDateInRange', {
                startDate: format(startDate, 'MM/dd/yy'),
                endDate: format(endDate, 'MM/dd/yy')
            });
        }
        if (!isValidDateFormat(formattedDate)) {
            return t('errors.invalidDateFormat');
        }
        const { billing: { daysDelinquent }, product } = accountSummaryResponse;
        const endDateForPayment = getEndDateForPayment(daysDelinquent, product);
        return getDateError(formatDateStringToObject(formattedDate), endDateForPayment, getMaximumPaymentDays(daysDelinquent, product));
    };
}
export default datePickerValidation;
